import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function Email ({ name = 'email' }) {
  const value = useValue(name)

  return (
    <a href={'mailto:' + value}>
      {value}
    </a>
  )
}
